export default __webpack_public_path__ + "static/media/clasic.797de450.jpg";